import ImagesIconsDashboardNoDataAsksSvg from '@/public/images/icons/dashboard/no-data/asks.svg';
import ImagesIconsDashboardNoDataBidsSvg from '@/public/images/icons/dashboard/no-data/bids.svg';
import ImagesIconsDashboardNoDataOrdersSvg from '@/public/images/icons/dashboard/no-data/orders.svg';
import ImagesIconsDashboardNoDataSalesSvg from '@/public/images/icons/dashboard/no-data/sales.svg';
import ImagesIconsDashboardNoDataWishlistSvg from '@/public/images/icons/dashboard/no-data/wishlist.svg';

export {
  ImagesIconsDashboardNoDataAsksSvg,
  ImagesIconsDashboardNoDataBidsSvg,
  ImagesIconsDashboardNoDataOrdersSvg,
  ImagesIconsDashboardNoDataSalesSvg,
  ImagesIconsDashboardNoDataWishlistSvg,
};
